<template>
  <div class="form_add_page" v-loading="isLoading">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        {{ $route.query.operate }}
      </div>
      <div class="flex">
        <zip-btn
          :name="claimantInfo.claimStatementNum"
          v-show="
            fileList && fileList.length > 0 && $route.query.operate != '审核'
          "
          :fileList="fileList"
        />
        <el-button
          size="mini"
          type="primary"
          @click="handleHistory"
          style="margin-right:10px;"
          >历史索赔记录</el-button
        >

        <div
          class="button_list flex-right"
          v-if="$route.query.operate === '审核'"
        >
          <zip-btn
            :name="claimantInfo.claimStatementNum"
            v-show="fileList && fileList.length > 0"
            :fileList="fileList"
          />

          <el-button
            size="mini"
            v-if="
              claimantInfo.status == '3' ||
                claimantInfo.status == '21' ||
                claimantInfo.status == '16'
            "
            type="success"
            @click="handleExamine(1)"
            >正审通过</el-button
          >
          <el-button
            size="mini"
            v-if="claimantInfo.status == '15' || claimantInfo.status == '17'"
            type="success"
            @click="handleExamine(1)"
            >通过</el-button
          >

          <el-button
            size="mini"
            v-if="
              hasAnyRole(['索赔经理']) &&
                (claimantInfo.status == 3 ||
                  claimantInfo.status == 16 ||
                  claimantInfo.status == 21)
            "
            type="success"
            @click="handleExamine(4)"
            >加签(部长)</el-button
          >
          <el-button
            size="mini"
            v-if="
              hasAnyRole(['OTS部部长']) &&
                (claimantInfo.status == 15 || claimantInfo.status == 18)
            "
            type="success"
            @click="handleExamine(4)"
            >加签(章总)</el-button
          >
          <el-button size="mini" type="danger" @click="handleExamine(2)"
            >驳回</el-button
          >
          <el-button
            size="mini"
            v-if="
              claimantInfo.status == '3' ||
                claimantInfo.status == '21' ||
                claimantInfo.status == '16'
            "
            type="warning"
            @click="handleExamine(3)"
            >拒赔</el-button
          >
          <el-button size="mini" type="primary" @click="back"
            >返回列表</el-button
          >
          <el-button
            v-if="$route.query.enableNext === '1'"
            :loading="completeBtn"
            size="mini"
            type="primary"
            @click="getNextData('noExamine')"
            >下一条</el-button
          >
        </div>
      </div>
    </div>
    <Detail
      v-if="formLoading"
      ref="detailRef"
      :claimantInfo.sync="claimantInfo"
      :fieldsData="fieldsData"
      :happenDateError.sync="happenDateError"
      :faultError.sync="faultError"
      :previewFile="previewList"
    />

    <!-- 驳回弹窗 -->
    <el-dialog :title="examineName" width="550px" :visible.sync="showExamine">
      <el-form
        ref="examineForm"
        :model="examineForm"
        :rules="examineRules"
        label-width="120px"
        :inline="true"
        label-position="top"
      >
        <el-form-item
          :label="'请选择' + examineName + '原因'"
          prop="reason"
          style="width:100%"
          v-if="examineName !== '加签'"
        >
          <el-select v-model="examineForm.reason" style="width:100%" filterable clearable>
            <el-option
              v-for="(item, index) in reasonList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="examineName === '加签'"
          :label="'请填写' + examineName + '原因'"
          prop="remark"
          style="width:100%"
        >
          <el-input
            type="textarea"
            v-model="examineForm.remark"
            maxlength="1000"
            show-word-limit
            style="width:100%"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="examineForm.reason === '其他'"
          :label="'请填写' + examineName + '原因'"
          prop="remark"
          style="width:100%"
        >
          <el-input
            type="textarea"
            v-model="examineForm.remark"
            maxlength="1000"
            show-word-limit
            style="width:100%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showExamine = false">取 消</el-button>
        <el-button type="primary" @click="confirmExamine">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 审核完成弹窗 -->
    <el-dialog
      :visible.sync="showComplete"
      width="420px"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      center
    >
      <div style="text-align: center; width: 100%">
        <i
          class="el-icon-warning-outline"
          style="color: #E99D42; margin-right: 13px"
        />{{ completeTip }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="$route.query.enableNext === '1'"
          :loading="completeBtn"
          type="primary"
          size="mini"
          @click="getNextData"
          >下一条</el-button
        >
        <el-button
          :loading="completeBtn"
          type="primary"
          size="mini"
          @click="back"
          >返回列表</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      width="80%"
      :close-on-click-modal="false"
      title="历史记录"
      :visible.sync="historyDialog"
    >
      <historyList
        ref="historyRef"
        :vin="claimantInfo.vin"
        :claimantNum="claimantInfo.claimStatementNum"
      />
    </el-dialog>
  </div>
</template>

<script>
import { kdgetClimantDetail } from "@/api/seek";
import {
  auditClaimant,
  countersignClaimant,
  climantList
} from "@/api/kdsuopei";
import { setStorage, getStorage } from "@/util/localStor";
import Translate from "@/components/translate";
import { getDictItem, getDictValue } from "@/util/dict";
import ViewImgVideo from "@/components/viewImgVideo.vue";
import zipBtn from "@/components/downloadZip";
import historyList from "./components/historyList.vue";
import Detail from "./components/newDetail.vue";
import { getCurrentRoles, hasAnyRole } from "@/utils/role";

export default {
  components: {
    zipBtn,
    Translate,
    ViewImgVideo,
    historyList,
    Detail
  },
  data() {
    return {
      submitData: {},
      fileList: [],
      role: "",
      userRoles: [],
      historyDialog: false,
      previewList: [],
      happenDateError: false, //发生日期错误
      examineName: "", // 审核弹窗名称：驳回 | 拒赔
      showExamine: false, // 审核弹窗
      showComplete: false, // 审核完成弹窗
      completeTip: "", // 审核完成提示
      completeBtn: false, // 审核完成弹窗按钮状态
      isLoading: false, // 页面加载状态
      formLoading: false,
      claimantInfo: {}, // 表单数据
      reasonList: [], // 审核原因下拉列表
      examineForm: {}, // 审核表单数据
      examineRules: {
        reason: [{ required: true, message: " " }],
        remark: [{ required: true, message: " " }]
      }, // 审核表单验证规则
      faultError: false, // 主因故障件错误
      // 字段信息
      fieldsData: {
        vin: [{ required: false, message: " " }],
        claimNode: [{ required: true, message: " " }],
        claimType: [{ required: true, message: " " }],
        claimStatementNum: [{ required: true, message: " " }],
        roadHaul: [{ required: true, message: " " }],
        productionDate: [{ required: true, message: " " }],
        salesDate: [{ required: true, message: " " }],
        happenDate: [
          { required: true, message: " " },
          { validator: this.validateHappenDate }
        ],
        problemCategory: [{ required: true, message: " " }],
        faultPartNumber: [{ required: true, message: " " }],
        boxNumber: [{ required: true, message: " " }],
        cartonNumber: [{ required: true, message: " " }],
        changeQuantity: [{ required: true, message: " " }],
        repairPlan: [{ required: true, message: " " }],
        sourceOfComponents: [],
        workingHours: [{ required: true, message: " " }],
        shippingFee: [{ required: true, message: " " }],
        faultPartUnitPrice: [{ required: true, message: " " }],
        faultPartNameZh: [{ required: true, message: " " }],
        otherExpenses: [],
        otherExpensesCn: [],
        symptom: [],
        symptomCn: [],
        preliminaryCauseOfFailure: [],
        preliminaryCauseOfFailureCn: [],
        processingScenarios: [],
        processingScenariosCn: [],
        managementFeeRate: [{ required: true, message: " " }],

        manHour: [{ required: true, message: " " }],
        hourlyRate: [{ required: true, message: " " }],
        freight: [{ required: true, message: " " }],
        tariff: [{ required: true, message: " " }],
        travelPrice: [],
        otherTotalCost: [],
        openBoxDate: [{ required: true, message: " " }],
        lbjzyList: [{ required: true, message: " ", trigger: "blur" }]
      }
    };
  },
  watch: {},
  created() {},
  async mounted() {
    this.userRoles = getCurrentRoles();
    this.role = this.userRoles[0] || sessionStorage.getItem("role") || "";
    let isHistory = localStorage.getItem("his");
    if (isHistory == 2) {
      let history = getStorage("history");
      if (
        JSON.stringify(history) !== "{}" &&
        this.$route.query.operate !== "查看详情"
      ) {
        this.historyDialog = history.show;
        this.$nextTick(() => {
          this.$refs.historyRef.showHistoryData();
        });
      }
    }
    if (this.$route.query?.claimantId) {
      this.isLoading = true;
      const res = await kdgetClimantDetail(this.$route.query?.claimantId);
      if (res.status == 0) {
        this.claimantInfo = res.data || {};
        this.claimantInfo.oldResponsibilityList = JSON.stringify(
          res.data.kdClaimFaultyPartsEntityListzeren || []
        );
      } else {
        this.$DonMessage.error(res.message);
      }
      this.isLoading = false;
    }
    this.fileList = this.claimantInfo.kdClaimFaultyPartsEntityList?.reduce(
      (acc, item) => {
        if (item.fileList && item.fileList.length > 0) {
          acc.push(...item.fileList);
        }

        return acc;
      },
      []
    ); // 初始值为空数组
    this.previewList = this.fileList?.filter(item => {
      return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
    });
    this.$nextTick(() => {
      this.formLoading = true;
    });
  },
  methods: {
    hasAnyRole,
    // 提交时再重新计算总费用
    // 提交时计算总工时等值
    getFinalPrice(arr) {
      if (arr && arr.length > 0) {
        let materialTotal = 0;
        let workingHoursTotal = 0;
        let laborCostTotal = 0;
        let freightTotal = 0;
        let tariffTotal = 0;
        let otherTotal = 0;
        let travelTotal = 0;
        let workingHourArr = [];
        arr?.map(item => {
          if (item.repairPlan != 0) {
            let newWorkingHours = item.workingHours * item.changeQuantity;
            workingHourArr.push(newWorkingHours);
          } else {
            let newWorkingHours = item.workingHours;
            workingHourArr.push(newWorkingHours);
          }
          materialTotal += item.materialCost ? item.materialCost : 0; // 计算材料总费用
          laborCostTotal += item.laborCost ? item.laborCost : 0; // 计算工时总费用
          freightTotal += item.shippingFee ? item.shippingFee : 0; // 计算总运费
          tariffTotal += item.tariff ? item.tariff : 0; // 计算总关税
          otherTotal += item.otherExpenses ? item.otherExpenses : 0; // 计算其他总费用
          travelTotal += item.travelPrice ? item.travelPrice : 0; // 计算差旅总费用
        });
        workingHoursTotal = workingHourArr.reduce(
          (accumulator, currentValue) => accumulator + currentValue,
          0
        ); // 计算总工时
        this.$set(this.submitData, "materialTotalCost", materialTotal);
        this.$set(this.submitData, "manHour", workingHoursTotal);
        this.$set(this.submitData, "totalCostOfWork", laborCostTotal);
        this.$set(this.submitData, "freight", freightTotal);
        this.$set(this.submitData, "tariff", tariffTotal);
        this.$set(this.submitData, "otherTotalCost", otherTotal);
        this.$set(this.submitData, "travelPrice", travelTotal);
      } else {
        this.$set(this.submitData, "materialTotalCost", undefined);
        this.$set(this.submitData, "manHour", undefined);
        this.$set(this.submitData, "totalCostOfWork", undefined);
        this.$set(this.submitData, "freight", undefined);
        this.$set(this.submitData, "tariff", undefined);
        this.$set(this.submitData, "otherTotalCost", undefined);
      }
      if (
        (this.submitData.totalCostOfWork ||
          this.submitData.totalCostOfWork === 0) &&
        (this.submitData.materialTotalCost ||
          this.submitData.materialTotalCost === 0) &&
        (this.submitData.otherTotalCost ||
          this.submitData.otherTotalCost === 0) &&
        (this.submitData.freight || this.submitData.freight === 0) &&
        (this.submitData.tariff || this.submitData.tariff === 0)
      ) {
        this.$set(
          this.submitData,
          "claimTotalCost",
          Number(this.submitData.totalCostOfWork) +
            Number(this.submitData.materialTotalCost) +
            Number(this.submitData.otherTotalCost) +
            Number(this.submitData.freight) +
            Number(this.submitData.tariff)
        );
      } else {
        this.$set(this.submitData, "claimTotalCost", undefined);
      }
    },
    // 打开历史详情记录
    handleHistory() {
      this.historyDialog = true;
      this.$nextTick(() => {
        this.$refs.historyRef.initData();
      });
    },
    // 获取详情数据
    async getDetailData() {
      this.isLoading = true;
      this.previewList = [];
      const res = await kdgetClimantDetail(this.$route.query?.claimantId);
      if (res.status == 0) {
        this.claimantInfo = res.data || {};
        this.claimantInfo.oldResponsibilityList = JSON.stringify(
          res.data.kdClaimFaultyPartsEntityListzeren || []
        );
        this.fileList = this.claimantInfo.kdClaimFaultyPartsEntityList?.reduce(
          (acc, item) => {
            if (item.fileList && item.fileList.length > 0) {
              acc.push(...item.fileList);
            }

            return acc;
          },
          []
        ); // 初始值为空数组
        this.previewList = this.fileList?.filter(item => {
          return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
        });

        this.$nextTick(() => {
          this.formLoading = true;
          this.$refs.detailRef.initresponsibility();
        });
      } else {
        this.$DonMessage.error(res.message);
      }
      this.isLoading = false;
    },
    // 校验发生日期
    async validateHappenDate(rule, value, callback) {
      if (this.happenDateError) {
        callback(new Error("提示：请联系所在地区服务经理维护预设数据"));
      } else {
        callback();
      }
    },
    // 校验故障件件号
    validateFaultPartNumber(rule, value, callback) {
      if (this.faultError) {
        callback(
          new Error(
            "提示：当前故障件暂时无法索赔，请联系所在地区服务经理进行维护"
          )
        );
      } else {
        callback();
      }
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 获取翻译值
    getTranslateVal(field, value) {
      this.$set(this.claimantInfo, field, value);
    },
    // 审核
    async audit(status, remark) {
      this.$refs.detailRef.$refs.form.validate(async valid => {
        // 正审时校验必填项
        if (
          valid == false &&
          this.examineName !== "驳回" &&
          this.examineName !== "拒赔"
        ) {
          this.$notify.error({
            message: "信息填写完整再提交",
            offset: 100,
            duration: 2000
          });
          return;
        } else {
          this.submitData = {};
          this.submitData = JSON.parse(JSON.stringify(this.claimantInfo));
          this.submitData.newResponsibilityList = JSON.stringify(
            this.submitData.kdClaimFaultyPartsEntityListzeren || []
          );
          let faultPartsList = [];
          let oldFaultPartsList = [
            ...this.submitData.kdClaimFaultyPartsEntityList
          ];
          this.submitData.kdClaimFaultyPartsEntityList?.map(item => {
            if (item.faultPartNumber) {
              faultPartsList.push(item);
            }
          });
          this.submitData.kdClaimFaultyPartsEntityList = faultPartsList;

          if (
            oldFaultPartsList &&
            this.submitData.kdClaimFaultyPartsEntityList
          ) {
            if (
              oldFaultPartsList.length !=
              this.submitData.kdClaimFaultyPartsEntityList.length
            ) {
              this.getFinalPrice(this.submitData.kdClaimFaultyPartsEntityList);
            }
          }
          this.submitData.status = status;
          this.submitData.remark = remark;
          let arr = [...this.claimantInfo.kdClaimFaultyPartsEntityListzeren];
          arr?.forEach((data, i) => {
            this.claimantInfo.kdClaimFaultyPartsEntityList?.map(item => {
              if (data.faultPartId == item.faultPartId) {
                data.faultPartId = item.faultPartId;
                data.claimStatementId = item.claimStatementId;
                data.faultPartName = item.faultPartName;
                data.faultPartNameZh = item.faultPartNameZh;
                data.faultPartNumber = item.faultPartNumber;
              }
            });
          });
          this.claimantInfo.kdClaimFaultyPartsEntityListzeren = [...arr];
          let canSubmit = true;
          if (this.examineName !== "驳回" && this.examineName !== "拒赔") {
            this.claimantInfo.kdClaimFaultyPartsEntityListzeren?.map(
              (item, i) => {
                if (item.faultPartId == "") {
                  this.$DonMessage.error("请选择责任方故障件件号后再提交");
                  canSubmit = false;
                }
              }
            );
          } else {
            var filteredArray = [];
            filteredArray = this.claimantInfo.kdClaimFaultyPartsEntityListzeren?.filter(
              item => item.faultPartNumber !== ""
            );
          }
          if (this.submitData.oldResponsibilityList == "[]") {
            this.submitData.oldResponsibilityList = null;
          }
          if (canSubmit) {
            this.isLoading = true;
            this.submitData = {
              ...this.submitData,
              lbjzy: this.claimantInfo.lbjzy,
              claimStatementId: this.claimantInfo.claimStatementId,
              kdClaimFaultyPartsEntityListzeren:
                this.examineName == "驳回" || this.examineName == "拒赔"
                  ? filteredArray
                  : this.claimantInfo.kdClaimFaultyPartsEntityListzeren,
              status: status,
              symptomCn: this.claimantInfo.symptomCn,
              preliminaryCauseOfFailureCn: this.claimantInfo
                .preliminaryCauseOfFailureCn,
              processingScenariosCn: this.claimantInfo.processingScenariosCn,
              remark: this.examineForm.remark
            };
            if (status == 15 || status == 17) {
              try {
                var res = await countersignClaimant({ data: this.submitData });
                if (res.status == 0) {
                  this.isLoading = false;
                  this.completeTip = `KD索赔订单 ${this.claimantInfo.claimStatementId} 已${this.examineName}`;
                  this.showComplete = true;
                } else {
                  this.isLoading = false;
                  this.$DonMessage.error(res.message);
                }
              } catch (error) {
                this.isLoading = false;
              }
            } else {
              try {
                var res = await auditClaimant({ data: this.submitData });
                if (res.status == 0) {
                  this.isLoading = false;
                  this.completeTip = `KD索赔订单 ${this.claimantInfo.claimStatementId} 已${this.examineName}`;
                  this.showComplete = true;
                } else {
                  this.isLoading = false;
                  this.$DonMessage.error(res.message);
                }
              } catch (error) {
                this.isLoading = false;
              }
            }
          }
        }
      });
    },
    // 点击审核
    async handleExamine(type) {
      if (type == 1) {
        if (!hasAnyRole(["索赔经理"])) {
          this.examineName = "正审通过";
        } else {
          this.examineName = "通过";
        }
        this.$refs.detailRef.pageIndex = "detail";
        if (this.$refs.detailRef.pageIndex == "detail") {
          this.$nextTick(() => {
            this.audit(19);
          });
        }
      } else {
        if (type == 2) {
          this.isLoading = true;
          this.examineName = "驳回";
          this.reasonList = await getDictItem("rejectCause");
        }
        if (type == 3) {
          this.isLoading = true;
          this.examineName = "拒赔";
          this.reasonList = await getDictItem("claimsRejectCause");
        }
        if (type == 4) {
          this.isLoading = true;
          this.examineName = "加签";
        }
        this.isLoading = false;
        this.showExamine = true;
        this.examineForm = {};
        this.$nextTick(() => {
          this.$refs.examineForm.clearValidate();
        });
      }
    },
    // 下一条
    async getNextData(type) {
      this.completeBtn = true;
      const query = JSON.parse(this.$route.query?.searchObj);
      if (type === "noExamine") {
        this.isLoading = true;
        query.page.pageNum = query.page.pageNum + 1;
      }

      const res = await climantList(query);
      if (res.status == 0) {
        this.completeBtn = false;
        this.isLoading = false;
        this.showComplete = false;
        if (res.data.records[0]) {
          setStorage("claimantData", res.data.records[0]);
          this.$router.replace({
            path: "/kd-claimant/detail",
            query: {
              claimantId: res.data.records[0].claimStatementId,
              searchObj: JSON.stringify({
                ...query
              }),
              enableNext: this.$route.query?.enableNext,
              operate: this.$route.query?.operate
            }
          });
          this.getDetailData();
        } else {
          this.$DonMessage.warning("筛选索赔单已审核完！")
        }
      } else {
        this.completeBtn = false;
        this.isLoading = false;
        this.$DonMessage.error(res.message);
      }
    },
    // 确认
    confirmExamine() {
      this.$refs.examineForm.validate(async valid => {
        if (!valid) {
          return;
        }

        const submitData =
          this.examineForm.reason === "其他" ||
          this.examineForm.reason === "加签"
            ? this.examineForm.remark
            : this.examineForm.reason;
        this.showExamine = false;
        this.$refs.detailRef.pageIndex = "detail";
        if (this.examineName == "驳回") {
          let status = 4;

          if (hasAnyRole(["OTS部部长"])) {
            status = 16;
          }
          if (hasAnyRole(["章总"])) {
            status = 18;
          }

          if (this.$refs.detailRef.pageIndex == "detail") {
            this.$nextTick(() => {
              this.audit(status, submitData);
            });
          }
        } else if (this.examineName == "加签") {
          if (hasAnyRole(["索赔经理"])) {
            if (this.$refs.detailRef.pageIndex == "detail") {
              this.$nextTick(() => {
                this.audit(15, submitData); //给肖部加签
              });
            }
          }
          if (hasAnyRole(["OTS部部长"])) {
            if (this.$refs.detailRef.pageIndex == "detail") {
              this.$nextTick(() => {
                this.audit(17, submitData); //给肖部加签
              });
            }
          }
        } else {
          if (this.$refs.detailRef.pageIndex == "detail") {
            this.$nextTick(() => {
              this.audit(5, submitData);
            });
          }
        }
      });
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.form_add_page {
  padding-bottom: 20px;
  ::v-deep .el-table__body .el-input {
    width: unset;
  }
  ::v-deep .el-textarea__inner {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
      "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
  .top-container {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    padding: 15px 32px 15px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .status-container {
    display: flex;
    align-items: baseline;
    padding: 13px 44px;
    border-bottom: 1px solid #dcdee0;
    .status {
      margin: 0 85px;
    }
    .btn {
      color: #4084ff;
      padding: 0;
      font-size: 16px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .form-container {
    margin-top: 34px;
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .tips {
    line-height: 20px;
    color: #cecece;
    font-size: 14px;
  }
  .err-nowarp {
    ::v-deep .el-form-item__error {
      white-space: nowrap;
    }
  }
  .table-container {
    .is-error {
      ::v-deep .el-input__inner {
        border-color: #f56c6c;
      }
    }
  }
  .is-error {
    color: #f56c6c;
    font-size: 12px;
  }
  .fanyi-box {
    ::v-deep .el-textarea__inner {
      height: 100px;
    }
    .textAreaTipBtn {
      cursor: pointer;
      width: fit-content;
      color: #1890ff;
    }
  }
}
.file {
  .down-icon {
    margin-left: 10px;
    color: #1890ff;
  }
  .file-list {
    margin: 0 10px;
    padding: 0 5px;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
    display: flex;
    i {
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 12px;
      margin-left: 5px;
    }
    .right {
      font-size: 12px;
      padding: 0 5px;
      border: 1px solid #4095e5;
      text-align: center;
      margin-left: 30px;
      border-radius: 6px;
      height: 26px;
      line-height: 26px;
      box-sizing: border-box;
      opacity: 0;
    }
  }
  .file-list:hover {
    background: rgb(243, 246, 249);
    color: #4095e5;
    .right {
      opacity: 1;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 400px;
}
</style>
